export default __webpack_public_path__ + "static/armis-929d117803a991498f5832cdebcb6483.png";